import { useColourPalette } from "~/js/api/colour-palette/get-colour-palette";
import { SaveColorProvider } from "~/react/save-color";
import { SaveColorButtonsWrapper } from "~/react/components/save-color/save-color-buttons-wrapper";
import { useAddToColorCollectionModalStore } from "../../../js/stores/add-to-color-collection-modal-store";
import { SharedIcon } from "~/react/components/shared/shared-icon";
import { useLinkColors } from "~/js/api/my-saved-colors/get-liked-colors";
import { useSyncLoaderStore } from "~/js/stores/sync-loader-store";

export function ColourPaletteSuggestions({ colourCode }) {
  const { data } = useColourPalette(colourCode);
  const openModal = useAddToColorCollectionModalStore((state) => state.openModal);
  const colorsMutation = useLinkColors();
  const setIsLoading = useSyncLoaderStore((state) => state.setIsLoading);

  const clickSaveHandler = () => {
    if(data?.length) {
      colorsMutation.mutate({
        colorCodes: data.map((colour) => colour?.colourCode),
        successHandler: () => {
          setIsLoading(false);
        },
        errorHandler: () => setIsLoading(false),
      });
    }

  }

  const clickAddToCollectionHandler = () => {
    const colourParams = data?.reduce((params, colour) => params + '&code=' + colour?.colourCode, '');
    openModal('/umbraco/api/colourCollections/addToCollectionForm?' + colourParams);
  }

  return (
      <div className="colour-palette-suggestions collection-detail__content">
        {!!data?.length && (
          <div className="colour-listing">
            <h2>Your colour palette suggestions</h2>
            <div className="result-container">
              <div className="chips">
                {data.map((colour) => (
                  <div className="colour-chip colour-chip-expand ">
                      <div className="colour-chip-inner">
                        <div className="colour-chip-colour"
                             onClick={(e) => {
                               if(e.target === e.currentTarget) window.location.href = colour?.url;
                             }}
                             style={{
                               backgroundColor: "rgb(" + colour?.colourRGB + ")",
                               color: "rgba(" + colour?.colourRGB + ", .6)"
                             }}
                        >
                            <SaveColorProvider data={colour?.colourActions}>
                              <SaveColorButtonsWrapper />
                            </SaveColorProvider>
                        </div>
                        <div className="colour-chip-info">
                          <p className="colour">{colour?.colourName}</p>
                          <p>{colour?.colourCode}</p>
                        </div>
                      </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="colour-palette-suggestions__actions">
              <button
                type="button"
                className="button grey"
                aria-label="Save all colours"
                onClick={() => clickSaveHandler()}
              >
                <SharedIcon iconName="#sprite-heart" className="icon-heart"/>
                <span className="">Save all colours</span>
              </button>

              <button
                type="button"
                className="button grey"
                aria-label="Add colours to collection"
                onClick={() => clickAddToCollectionHandler()}
              >
                <SharedIcon iconName="#sprite-plus" className="icon-plus"/>
                <span className="">Add colours to collection</span>
              </button>
            </div>
          </div>
        )}
      </div>
  );
}
